import type React from 'react';

import { Badge } from '#src/app/shared/components/adminShadcn';

import { useStatusBadge } from './hooks/useStatusBadge';

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
	const {
		data: { variant },
	} = useStatusBadge({ status });
	return <Badge variant={variant}>{status}</Badge>;
};
